import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { take } from 'rxjs';
import { SweetAlertService } from 'src/app/_avmin/services/sweet-alert.service';
import { POSService } from './pos.service';
import { ToastrService } from 'ngx-toastr';

const allowedRoutes = [
  '/pos',
  '/pos/payment'
];

export const POSGuard: CanDeactivateFn<any> = (
  component: any,
  currentRoute: ActivatedRouteSnapshot,
  currentState: RouterStateSnapshot,
  nextState: RouterStateSnapshot
) => {
  if (allowedRoutes.find(r => r === nextState.url)) {
    return true;
  }

  const posService = inject(POSService);
  const swal = inject(SweetAlertService);
  const toastr = inject(ToastrService);

  return new Promise<boolean>(resolve => {

    posService.sale$
      .pipe(take(1))
      .subscribe(sale => {
        if (!sale?.id) {
          resolve(true);
          return;
        }

        swal.fire({
          title: 'Discard Sale',
          text: 'You have an open sale. Are you sure you want to discard it?',
          icon: 'error',
          confirmButtonText: 'Yes, discard sale',
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-danger'
          }
        }).then(result => {
          if (!result.isConfirmed) {
            resolve(result.isConfirmed);
          } else {
            posService.discard().subscribe(() => {
              toastr.error('Sale discarded.');
              resolve(true);
            }, (err) => {
              swal.handleError(err);
              resolve(false);
            });
          }
        });
      });
  })
}
